import { useQuery } from "@tanstack/react-query";
import { useAccountService } from "../../useAdminServices";
import { useHotel } from "../../../contexts/HotelContext";
import { queryKeys } from "../../../lib/react-query/queryClient";
import { AdminBootstrapDto } from "../../../services/admin/types/account.types";

/**
 * Fetches all admin shell initialization data in a single request.
 * Replaces 7+ individual API calls (permissions, settings, subscription, PMS, etc.).
 * Only enabled when user has a hotel and account service is ready.
 */
export const useAdminBootstrapQuery = () => {
  const accountService = useAccountService();
  const { myHotelInfo } = useHotel();
  const hotelId = myHotelInfo?.hotelId;

  return useQuery<AdminBootstrapDto>({
    queryKey: queryKeys.bootstrap(hotelId),
    queryFn: async () => {
      if (!accountService) throw new Error("Account service not initialized");

      const result = await accountService.getBootstrapData();
      if (!result.success) {
        throw new Error(result.error?.message || "Failed to fetch bootstrap data");
      }

      return result.data;
    },
    enabled: !!accountService && !!hotelId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
